// 产品推荐tab
import React, { useMemo } from 'react';
import { ProductCard } from '../ProductRecommendTab/index';
import Summary from '@/components/Summary';
import useCopilotValueStore from '@/stores/copilotValueStore';

const ProductRecommend: React.FC = () => {
  const { copilotValue8 } = useCopilotValueStore();

  const loading = useMemo(() => copilotValue8.loading, [copilotValue8.loading]);
  const products = useMemo(() => copilotValue8.product_info || [], [copilotValue8.product_info]);

  if (loading) {
    return (
      <div className="min-h-[200px] text-center text-sm text-black">
        Ai已识别客户投顾需求，正在检索市场行情数据生成完整洞察内容，请稍后…
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* 产品卡片列表 */}
      <div className="space-y-3">
        {products.map((product, index) => (
          <div
            key={index}
            // className={`transition-all duration-1000 ${
            //   isDataChanging ? 'opacity-80 scale-[0.98]' : 'opacity-100 scale-100'
            // }`}
          >
            <ProductCard product={product} />
          </div>
        ))}
      </div>
      <Summary
        isShowSuggestions={false}
        title="综合投资建议"
        content={copilotValue8.综合投资建议 || ''}
      />
    </div>
  );
};

export default ProductRecommend;
